import SearchString from "search-string";

/**
 * Extracts unique values from full question list for specific fields.
 * @param {Question[]} questionList
 * @returns {{
 *   owner: string[],
 *   status: string[],
 *   assignee: string[],
 *   questionGroup: string[]
 * }}
 */
export function getAvailableFilterOptions(questionList) {
  const ownerSet = new Set();
  const statusSet = new Set();
  const assigneeSet = new Set();
  const questionGroupSet = new Set();

  questionList.forEach((question) => {
    if (question.owner) ownerSet.add(question.owner);
    if (question.stage) statusSet.add(question.stage); // assuming "stage" = "status"
    if (question.assignees) {
      question.assignees.forEach((assignee) => {
        assigneeSet.add(assignee);
      });
    }
    if (question.questionGroup) questionGroupSet.add(question.questionGroup);
  });

  return {
    Owner: Array.from(ownerSet),
    Status: Array.from(statusSet),
    Assignee: Array.from(assigneeSet),
    "Question Group": Array.from(questionGroupSet),
  };
}

/**
 * Parses the filteredKeywords string and returns an object with the same format as getAvailableFilterOptions.
 * @param {string} filteredKeywords
 * @returns {{
 *   Owner: string[],
 *   Status: string[],
 *   Assignee: string[],
 *   "Question Group": string[]
 * }}
 */
export function parseFilteredKeywords(filteredKeywords) {
  const filters = {
    Owner: [],
    Stage: [],
    Assignee: [],
    "Question Group": [],
  };

  const search = SearchString.parse(filteredKeywords);
  const conditions = search.getConditionArray();

  conditions.forEach(({ keyword, value }) => {
    switch (keyword) {
      case "assignees":
        filters.Assignee.push(...value.split(","));
        break;
      case "questionGroup":
        filters["Question Group"].push(...value.split(","));
        break;
      case "owner":
        filters.Owner.push(...value.split(","));
        break;
      case "stage":
        filters.Stage.push(...value.split(","));
        break;
      default:
        break;
    }
  });
  return filters;
}
